<template>
  <div>
    <upload-file-form
      v-if="podeAnexar"
      ref="uploadArquivo"
      :id="!!idContrato ? idContrato : 600"
      :id-entidade="!!idContrato ? idContrato : 600"
      :title="$t('label.upload_anexo')"
      :url="uriUpload"
      :auto-process-queue="false"
      @UPLOADFILE_SENDING="enviandoArquivo"
      @UPLOADFILE_FILE_ADDED="preencherDescricaoComNomeArquivo"
      @UploadArquivo__success="uploadSucesso">
      <v-text-field
        v-model="descricaoArquivo"
        :rules="[rules.required]"
        :counter="150"
        maxlength="150"
        :label="`${$t('label.descricao')}*`"
        required
      ></v-text-field>
    </upload-file-form>

    <div class="painel-anexo">
      <v-row>
        <div :disabled="!podeAnexar" class="botao-anexar">
          <v-btn icon
            @click="() => $refs.uploadArquivo.open()">
            <v-icon>
              attach_file
            </v-icon>
          </v-btn>
        </div>
        <span v-if="novoContrato" style="color: darkorange;" class="ma-3 ml-7">
          {{$t('message.upload_anexo_contrato_indisponivel')}}
        </span>
        <list-files
          :habilitar-exclusao="podeAnexar"
          v-if="!novoContrato"
          ref="listFiles"
          :uri="uri"
          @ListFiles__arquivos="(files) => $emit('FormAnexoArquivo__qtde', files.length)"></list-files>
      </v-row>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import UploadFileForm from '@/shared-components/upload/UploadFileForm';
import basePath from '@/common/functions/api-resource';
import ListFiles from '@/shared-components/files/ListFiles';

export default {
  name: 'PlanejamentoContratoFormAnexoArquivo',
  components: {
    UploadFileForm,
    ListFiles,
  },
  props: {
    idContrato: {
      type: Number,
      default: null,
    },
    novoContrato: Boolean,
  },
  data() {
    return {
      descricaoArquivo: null,
      rules: {
        required: (value) => !!value || this.$t('message.campo_obrigatorio'),
      },
    };
  },
  computed: {
    ...mapGetters('roles', [
      'getAllRoles',
    ]),
    uri() {
      const urlUpload = basePath('job', 'arquivo/contrato');
      return `${urlUpload}/${this.idContrato}`;
    },
    uriUpload() {
      const urlUpload = basePath('job', 'arquivo/contrato');
      return `${urlUpload}/${this.idContrato}/upload`;
    },
    hasRole() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter((el) => el === 'CONTRATO_CRUD' || el === 'CONT_UPLOAD_ARQ').length;
    },
    podeAnexar() {
      return !this.novoContrato && this.hasRole;
    },
  },
  methods: {
    enviandoArquivo(data, xhr, formData) {
      formData.append('descricao', encodeURI(this.descricaoArquivo));
    },
    preencherDescricaoComNomeArquivo(file) {
      this.descricaoArquivo = file.name;
    },
    uploadSucesso() {
      setTimeout(() => this.$refs.listFiles.refresh(), 1E3);
      this.$toast(this.$t('label.upload_arquivo_sucesso'));
    },
  },
};
</script>
<style scoped>
.anexo-desabilitado {
  padding: 12px 0 0 12px;
  font-size: 16px !important;
  color: red;
}
.painel-anexo .container.mx-0 {
  max-width: 97% !important;
}
</style>
